/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.userPinResetWithVerificationCode.internal

import kangaroorewards.appsdk.core.io.EmptyResponse
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class UserPinResetServiceImpl : UserPinResetService {

    private val userPinResetRequest = UserPinResetRequest()

    override suspend fun resetPin(
        overrideHeaders : Map<String, String>?,
        verificationCode: String,
        pinCode: String,
        email: String?,
        phone: String?,
        countryCode: String?    ): Result<EmptyResponse> {
        return userPinResetRequest.resetPin(
            overrideHeaders = overrideHeaders,
            verificationCode = verificationCode,
            pinCode = pinCode,
            email = email,
            phone = phone,
            countryCode = countryCode        ).toModel()
    }
}
